<div class="categories-list">
    <div class="w100 align-center space-between row category-header" i18n>
        <h2>Domains / Categories</h2>
        <div class="row gap-8">
            <rr-btn iconStart="add" type="Primary" (btnclick)="createCategory()"
                >Add Category</rr-btn
            >
        </div>
    </div>
    <div cdkDropList (cdkDropListDropped)="drop($event)">
        <div
            *ngFor="let category of structuredCategories; let i = index"
            cdkDrag
        >
            <app-category-item
                [category]="category"
                [streams]="allStreams"
                [streamOrder]="streamOrder"
                (showCreateCategory)="createCategory($event)"
                (editCategory)="editCategory($event)"
                (deleteCategory)="deleteCategory($event)"
            ></app-category-item>
        </div>
    </div>
</div>
